import { Outlet } from 'react-router-dom'
import { Suspense } from 'react'
import EngineNav from './components/EngineNav'
import './globals.css'

export default function App() {
  return (
    <div className="h-screen bg-gray-900 text-white antialiased flex flex-col">
      <EngineNav />
      <main className="flex-1 flex flex-col min-h-0">
        <Suspense fallback={
          <div className="flex items-center justify-center flex-1">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-300 mx-auto mb-4" />
              <p className="text-gray-400">Loading...</p>
            </div>
          </div>
        }>
          <Outlet />
        </Suspense>
      </main>
    </div>
  )
}
